var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.107 10.1539H10.7141V6.76109C10.7141 6.66288 10.6338 6.58252 10.5355 6.58252H9.46411C9.3659 6.58252 9.28554 6.66288 9.28554 6.76109V10.1539H5.89268C5.79447 10.1539 5.71411 10.2343 5.71411 10.3325V11.4039C5.71411 11.5022 5.79447 11.5825 5.89268 11.5825H9.28554V14.9754C9.28554 15.0736 9.3659 15.154 9.46411 15.154H10.5355C10.6338 15.154 10.7141 15.0736 10.7141 14.9754V11.5825H14.107C14.2052 11.5825 14.2855 11.5022 14.2855 11.4039V10.3325C14.2855 10.2343 14.2052 10.1539 14.107 10.1539Z",
    fill: "black",
    fillOpacity: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.867188C4.47768 0.867188 0 5.34487 0 10.8672C0 16.3895 4.47768 20.8672 10 20.8672C15.5223 20.8672 20 16.3895 20 10.8672C20 5.34487 15.5223 0.867188 10 0.867188ZM10 19.1708C5.41518 19.1708 1.69643 15.452 1.69643 10.8672C1.69643 6.28237 5.41518 2.56362 10 2.56362C14.5848 2.56362 18.3036 6.28237 18.3036 10.8672C18.3036 15.452 14.5848 19.1708 10 19.1708Z",
    fill: "black",
    fillOpacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCircle);
export default __webpack_public_path__ + "static/media/plus-circle.eb1a19e645b3e2ea03c3a55b79a3a41d.svg";
export { ForwardRef as ReactComponent };